import React, { createContext, useReducer, useContext } from "react";

/* 초기값 */
const initialMenus = {
  user: {
    AD: null,
    ADMIN: null,
  },
  loadDrop: false,
  menu: {
    dashboard: {
      no: 1,
      name: "대시보드",
      eName: "dashboard",
      link: "/",
      sub: null,
      permission: false,
      view: true,
    },
    ad: {
      no: 2,
      name: "광고관리",
      eName: "ad",
      link: null,
      open: true,
      permission: false,
      view: true,
      sub: {
        0: {
          sNo: 0,
          name: "광고현황",
          link: "/ad",
          eName: "",
          permission: false,
        },
        1: {
          sNo: 1,
          name: "소재등록",
          link: "/ad/add",
          eName: "add",
          permission: false,
        },
      },
    },
    advertiser: {
      no: 3,
      name: "광고주관리",
      eName: "advertiser",
      link: null,
      open: true,
      permission: false,
      view: true,
      sub: {
        0: {
          sNo: 0,
          name: "광고주등록",
          link: "/advertiser",
          eName: "",
          permission: false,
          view: true,
        },
        1: {
          sNo: 1,
          name: "광고주정보",
          link: "/advertiser/info",
          eName: "info",
          permission: false,
          view: true,
        },
      },
    },
    profile: {
      no: 4,
      name: "프로필",
      eName: "profile",
      link: "/profile",
      open: false,
      permission: true,
      view: false,
    },
  },
};

const adminCheck = (data) => {
  let arrCheck = Array.isArray(data) && data[0] === "*";
  if (arrCheck) {
    return true;
  } else {
    return false;
  }
};

/* 리듀서 설정값 */
function menuReducer(state, action) {
  switch (action.type) {
    case "userset":
      const perCheck = adminCheck(action.payload.ADMIN);
      return {
        ...state,
        user: {
          ...state.user,
          AD: action.payload.AD,
          ADMIN: !action.payload.ADMIN ? null : action.payload.ADMIN,
        },
        menu: {
          ...state.menu,
          dashboard: {
            ...state.menu.dashboard,
            permission: true,
          },
          ad: {
            ...state.menu.ad,
            permission: true,
            sub: {
              ...state.menu.ad.sub,
              0: {
                ...state.menu.ad.sub[0],
                permission: true,
              },
              1: {
                ...state.menu.ad.sub[1],
                permission: perCheck,
              },
            },
          },
          advertiser: {
            ...state.menu.advertiser,
            permission: perCheck,
            sub: {
              ...state.menu.advertiser.sub,
              0: {
                ...state.menu.advertiser.sub[0],
                permission: perCheck,
              },
              1: {
                ...state.menu.advertiser.sub[1],
                permission: perCheck,
              },
            },
          },
        },
      };
    case "loadingStart":
      return {
        ...state,
        loadDrop: true,
      };
    case "loadingEnd":
      return {
        ...state,
        loadDrop: false,
      };
    case "reset":
      return initialMenus;
    default:
      return state;
  }
}

const MenuStateContext = createContext(); // info context
const MenuDispatchContext = createContext(); // function context

export function MenuProvider({ children }) {
  const [state, dispatch] = useReducer(menuReducer, initialMenus);
  return (
    <MenuStateContext.Provider value={state}>
      <MenuDispatchContext.Provider value={dispatch}>
        {children}
      </MenuDispatchContext.Provider>
    </MenuStateContext.Provider>
  );
}

export function useMenuState() {
  const context = useContext(MenuStateContext);
  if (!context) {
    throw new Error("Cannot find MenuProvider");
  }
  return context;
}

export function useMenuDispatch() {
  const context = useContext(MenuDispatchContext);
  if (!context) {
    throw new Error("Cannot find MenuDispatchProvider");
  }
  return context;
}
